(() => {
  if (window.cdCrystalFestiveBackdrop) return;
  window.cdCrystalFestiveBackdrop = true;
  const desktop = window.matchMedia('(min-width: 750px)');
  let observer;
  let frame = 0;
  let hero;
  let picks;

  const sync = () => {
    frame = 0;
    if (!hero?.isConnected || !picks?.isConnected || !desktop.matches) return;
    const width = picks.getBoundingClientRect().width;
    const blend = Math.min(320, Math.max(200, window.innerWidth * .18));
    const height = picks.getBoundingClientRect().height + blend;
    if (!width || !height) return;
    for (const element of [hero, picks]) {
      element.style.setProperty('--cd-festive-art-width', width + 'px');
      element.style.setProperty('--cd-festive-art-height', height + 'px');
      element.style.setProperty('--cd-festive-blend', blend + 'px');
    }
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(sync);
  };

  const connect = () => {
    observer?.disconnect();
    hero = document.querySelector('#crystal-glass-pillars-v9[data-crystal-series-hero]');
    picks = document.querySelector('[data-featured-picks] > .fp-screen--crystal');
    if (!hero || !picks) return;
    sync();
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      observer.observe(picks);
    }
  };

  window.addEventListener('resize', schedule, { passive: true });
  desktop.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', () => {
    observer?.disconnect();
    schedule();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
})();
